import React, { useEffect, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ChakraProvider } from '@chakra-ui/react';
import customTheme from './theme/customTheme';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase';
import { useDispatch } from 'react-redux';
import Home from './pages/Home';
import SignIn from './pages/SignIn';
import Loading from './pages/Loading';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      suspense: true,
    },
  },
});

function App() {
  const dispatch = useDispatch();
  const [isSignedIn, setIsSignedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(
      auth,
      user => {
        if (user) {
          const emailDomain = user.email.split('@')[1];
          if (emailDomain === 'mlb.com') {
            setIsSignedIn(true);
            dispatch({ type: 'SET_USER', payload: user.email });
          } else {
            console.warn('App: Unauthorized domain detected.');
            auth.signOut();
            setIsSignedIn(false);
          }
        } else {
          setIsSignedIn(false);
        }
        setIsLoading(false);
      },
      error => {
        console.error('App: onAuthStateChanged error:', error);
        setIsSignedIn(false);
        setIsLoading(false);
      }
    );

    return () => unsubscribe();
  }, [dispatch]);

  if (isLoading) {
    return (
      <ChakraProvider theme={customTheme} toastOptions={{ defaultOptions: { position: 'top' } }}>
        <Loading />
      </ChakraProvider>
    );
  }

  return (
    <QueryClientProvider client={queryClient}>
      <ChakraProvider theme={customTheme} toastOptions={{ defaultOptions: { position: 'top' } }}>
        <Routes>
          <Route path="/" element={<>{isSignedIn ? <Home /> : <SignIn />}</>} />
        </Routes>
        <ReactQueryDevtools initialIsOpen={false} />
      </ChakraProvider>
    </QueryClientProvider>
  );
}

export default App;